import { CSSProperties, Dispatch, ReactNode, SetStateAction, useCallback, useEffect, useMemo, useState } from 'react';
import { RawMessage } from '../../../types/channel';
import { lightenColor, relevanceFuniction } from '../../../utils/boxShadov';
import useRootStore from '../../../hooks/useRootStore';
import { AiOutlineStar } from 'react-icons/ai';
import { message as antMessage } from 'antd';
import { AiFillStar } from 'react-icons/ai';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import Text from '../../Text/Text';
import { DataObject } from '../../../types';
import { parseJsonData } from '../../../helper/helper';
import { toJS } from 'mobx';

interface Props {
    message: RawMessage;
    name?: string;
    showReply?: boolean;
    isDelete?: boolean;
    color?: string;
    userId?: number;
    style?: CSSProperties;
    setPimp?: Dispatch<
        SetStateAction<
            | {
                  pimpType: 'pimp' | 'unPimp';
                  value: number | undefined;
              }
            | undefined
        >
    >;
    children?: ReactNode;
    titleOnPress?: () => void;
    isImportant: boolean;
}

const MessageHeader = ({
    message,
    name,
    color = '',
    showReply,
    userId,
    setPimp,
    children,
    titleOnPress,
    isDelete,
    isImportant,
}: Props) => {
    let colorFIX = '#' + color.replaceAll('#', '');

    const { getOneMember, channelUsers, channelData } = useRootStore().channelStore;
    const { pimpMessage, unPimpMessage } = useRootStore().chatStore;
    const { user } = useRootStore().authStore;
    const [activePimp, setActivePimp] = useState(false);
    const MESSAGE_STYLE = useMemo(() => relevanceFuniction(message), [activePimp]);
    const textSize = MESSAGE_STYLE.fontSize;
    // console.log('message', toJS(message));

    const myself = useMemo(() => channelUsers.find(e => e?.id === user?.id), [channelUsers, user]);

    const data: DataObject = useMemo(() => (message?.pimps ? parseJsonData(message.pimps) : {}), [message]);

    useEffect(() => {
        setActivePimp(data ? data.hasOwnProperty(user.id) : false);
    }, [user]);

    const onRelevance = () => {
        if (channelData.rByLocationType?.length) {
            antMessage.info('cannot be used in this group');
            return;
        } else {
            getOneMember(userId || 0);
        }
    };

    const PimpMesssage = useCallback(() => {
        if (channelData.rByLocationType?.length) return null;
        pimpMessage(user.id, message.id, message.channelSlug, message.timestamp, myself?.relevance ?? 0);
        setPimp &&
            setPimp({
                pimpType: 'pimp',
                value: myself?.relevance,
            });
        setActivePimp(true);
    }, [userId, message, myself, pimpMessage, setPimp, channelData.rByLocationType]);

    const UnPimpMesssage = useCallback(() => {
        if (channelData.rByLocationType?.length) return null;
        unPimpMessage(user.id, message.id, message.channelSlug, message.timestamp);
        const keys = Object.keys(data);
        const il = keys[0] === `${user?.id}` ? 1 : 0;
        setPimp &&
            setPimp({
                pimpType: 'unPimp',
                value: data[`${keys[il]}`],
            });
        setActivePimp(false);
    }, [userId, message, data, unPimpMessage, setPimp, user, channelData.rByLocationType]);

    const star = useMemo(() => {
        if (userId === user.id) return null;
        return activePimp ? (
            <AiFillStar color="#FFAA33" size={14} onClick={() => UnPimpMesssage()} />
        ) : (
            <AiOutlineStar size={14} color="#999" onClick={() => PimpMesssage()} />
        );
    }, [activePimp, userId, user, unPimpMessage, pimpMessage]);

    return (
        <Container $backColor={lightenColor(color ? colorFIX : '#dddddd')}>
            <HeaderContainer>
                <Button onClick={titleOnPress}>
                    {!isImportant ? (
                        <Text fontSize={textSize} color={colorFIX} fontWeight={700}>
                            {name ? name : 'Deleted user'}
                        </Text>
                    ) : (
                        <Text fontSize={textSize} color={colorFIX} fontWeight={700}>
                            Import message
                        </Text>
                    )}
                </Button>
                {!showReply && (
                    <div className="relevanceBox">
                        <div className="relevances">
                            <Button onClick={() => onRelevance()}>
                                <Text fontSize={'14px'} fontWeight={500} color="#EE35AF">
                                    {message?.minRelevance === -1 ? '' : message?.minRelevance}
                                </Text>
                            </Button>
                            <Button onClick={() => onRelevance()}>
                                <Text fontSize={'14px'} fontWeight={500} color="#999">
                                    {message?.relevance || 0}
                                </Text>
                            </Button>
                        </div>
                        {star}
                    </div>
                )}
            </HeaderContainer>
            <MessageContainer>{children}</MessageContainer>
        </Container>
    );
};
export default observer(MessageHeader);

const Container = styled.div<{ $backColor: string }>`
    display: flex;
    flex-direction: column;
    background-color: ${props => (props.$backColor ? props.$backColor : '#f44')};
    border-radius: 15px;
`;

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    gap: 15px;

    .relevanceBox {
        display: flex;
        gap: 7px;
        align-items: center;

        .relevances {
            display: flex;
            gap: 7px;
        }
    }
`;

const MessageContainer = styled.div`
    width: 100%;
`;

const Button = styled.button`
    background-color: transparent;
    outline: none;
    border: none;
    cursor: pointer;
`;
